import { CATALOG, CATEGORIES, GENERIC, findModel } from './catalog.js';
import { ICONS, iconSVG } from './icons.js';
import { paintDesign } from './painter.js';
import { DICT } from './order-i18n.js';

const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

const LANGS = ['ru', 'uz', 'en'];
const STYLES = ['street', 'clean', 'splash', 'idea'];
const PALETTE = {
  base: ['#0c0c0b', '#F7F7F2', '#9B9B95', '#2b2b29', '#D7FF00', '#E5332A', '#FF7A1A', '#FF5FA2', '#7B4DFF', '#2F6BFF', '#12B5A4', '#D9C7A3'],
  accent: ['#D7FF00', '#F7F7F2', '#0c0c0b', '#E5332A', '#FF7A1A', '#FF5FA2', '#7B4DFF', '#2F6BFF'],
  detail: ['#F7F7F2', '#0c0c0b', '#D7FF00', '#E5332A', '#FF5FA2', '#2F6BFF'],
};
const THUMB_DEVICE = { phone: 'phone', iqos: 'pocket', earbuds: 'earbuds', gamepad: 'gamepad' };
const STYLE_DEFAULTS = { splash: { baseColor: '#F7F7F2', iconColor: '#0c0c0b', textColor: '#0c0c0b' } };
const MAX_ICONS = 8, MAX_MB = 15, EXT_OK = ['png', 'jpg', 'jpeg', 'webp', 'svg', 'pdf'];

const params = new URLSearchParams(location.search);
const viewId = params.get('view');

const state = {
  lang: detectLang(),
  category: params.get('device') === 'pocket' ? 'iqos' : CATEGORIES.includes(params.get('device')) ? params.get('device') : 'phone',
  brand: null, model: null, other: '',
  design: {
    style: STYLES.includes(params.get('mode')) ? params.get('mode') : 'street',
    baseColor: '#0c0c0b', accentColor: '#D7FF00', icons: [], iconColor: '#F7F7F2', iconScale: 1,
    text: '', textColor: '#F7F7F2', finish: 'gloss', image: { scale: 1, x: 0, y: 0 },
  },
  delivery: 'courier', shuffle: 0, file: null, img: null, objUrl: null,
};
Object.assign(state.design, STYLE_DEFAULTS[state.design.style] || {});

let viewer = null, flat = null, builtKey = '', queued = false, deviceDirty = true;
let tg = null; // Telegram.WebApp when the configurator runs as a Telegram Mini App

const t = (k) => (DICT[state.lang] && DICT[state.lang][k]) || DICT.ru[k] || k;

// each language has its own pre-built page (/order, /uz/order, /en/order); <html lang> says which one this is
function detectLang() {
  const l = document.documentElement.lang;
  return LANGS.includes(l) ? l : 'ru';
}
// "/order" → "/uz/order" etc.
function localize(href, lang) {
  if (/^\/(assets|admin|api)(\/|$)/.test(href)) return href;
  const bare = href.replace(/^\/(uz|en)(?=\/|$)/, '') || '/';
  return lang === 'ru' ? bare : `/${lang}${bare === '/' ? '/' : bare}`;
}

/* ================================================================ device */
function brands() { return CATALOG[state.category]; }
function pickDefaults() {
  const first = brands()[0];
  state.brand = first.id;
  state.model = first.models[0] ? first.models[0].id : '__other';
}
function spec() {
  const { model } = findModel(state.category, state.brand, state.model);
  return { ...(model || GENERIC[state.category]), brand: state.brand };
}
function isOther() { return state.brand === 'other' || state.model === '__other'; }
function modelLabel() {
  if (isOther()) return state.other.trim();
  const { model } = findModel(state.category, state.brand, state.model);
  return model ? model.name : '';
}
function brandName() {
  const b = brands().find((x) => x.id === state.brand);
  return b && b.name ? b.name : 'other';
}

/* ================================================================ render UI */
function renderCats() {
  $('#cats').innerHTML = CATEGORIES.map((c) => `
    <button type="button" class="cat" data-cat="${c}" aria-pressed="${c === state.category}">
      <span class="cat-thumb">${window.FunDevices ? window.FunDevices.render(THUMB_DEVICE[c], 'street') : ''}</span>
      <b>${t('cat.' + c)}</b><small>${t('cat.' + c + '.d')}</small>
    </button>`).join('');
  $('#cat-note').textContent = t(`cat.${state.category}.note`);
}

function renderBrands() {
  $('#brands').innerHTML = brands().map((b) => `
    <button type="button" class="chip" data-brand="${b.id}" aria-pressed="${b.id === state.brand}">${b.name || t('f.otherBrand')}</button>`).join('');
  const b = brands().find((x) => x.id === state.brand);
  const sel = $('#model');
  sel.innerHTML = '';
  if (b && b.models.length) {
    for (const m of b.models) sel.add(new Option(m.name, m.id, false, m.id === state.model));
    sel.add(new Option(t('f.otherModel'), '__other', false, state.model === '__other'));
  }
  $('#model-field').hidden = !(b && b.models.length);
  $('#other-field').hidden = !isOther();
}

function renderStyles() {
  const dev = THUMB_DEVICE[state.category];
  $('#styles').innerHTML = STYLES.map((s) => `
    <button type="button" class="style-card" data-style="${s}" aria-pressed="${s === state.design.style}">
      <span class="thumb">${window.FunDevices ? window.FunDevices.render(dev, s, { name: state.design.text || 'FUNMODE' }) : ''}</span>
      <span><b>${t('mode.' + s)}</b><small>${t('mode.' + s + '.d')}</small></span>
    </button>`).join('');
  $('#upload-need').hidden = !(state.design.style === 'idea' && !state.file);
}

function renderSwatches() {
  const rows = { base: 'baseColor', accent: 'accentColor', detail: 'iconColor' };
  for (const [row, key] of Object.entries(rows)) {
    const cur = state.design[key].toLowerCase();
    const known = PALETTE[row].some((c) => c.toLowerCase() === cur);
    $(`#sw-${row}`).innerHTML = PALETTE[row].map((c) => `
      <button type="button" class="sw" style="--c:${c}" data-row="${row}" data-color="${c}" aria-pressed="${c.toLowerCase() === cur}" aria-label="${c}"></button>`).join('')
      + `<span class="sw-custom" data-on="${!known}" title="${t('f.custom')}"><input type="color" data-row="${row}" value="${cur}" aria-label="${t('f.custom')}"></span>`;
  }
}

function renderIcons() {
  const sel = state.design.icons;
  $('#icons').innerHTML = ICONS.map((ic) => {
    const on = sel.includes(ic.id);
    return `<button type="button" class="ic" data-icon="${ic.id}" aria-pressed="${on}" aria-label="${ic.id}" ${!on && sel.length >= MAX_ICONS ? 'disabled' : ''}>${iconSVG(ic.id)}</button>`;
  }).join('');
}

function renderSegs() {
  $$('#finish [data-finish]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.finish === state.design.finish)));
  $$('#delivery [data-delivery]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.delivery === state.delivery)));
  $('#city-field').hidden = state.delivery !== 'post';
}

function renderSummary() {
  $('#sum-device').textContent = modelLabel() || t('cat.' + state.category);
  $('#sum-style').textContent = `${t('mode.' + state.design.style)} · ${t('fin.' + state.design.finish)}`;
}

function applyI18n() {
  document.documentElement.lang = state.lang;
  document.title = t('meta.title');
  $$('[data-i18n]').forEach((el) => { const v = t(el.dataset.i18n); if (v.includes('<')) el.innerHTML = v; else el.textContent = v; });
  $$('[data-i18n-ph]').forEach((el) => el.setAttribute('placeholder', t(el.dataset.i18nPh)));
  $$('[data-i18n-aria]').forEach((el) => el.setAttribute('aria-label', t(el.dataset.i18nAria)));
  $$('.lang-link').forEach((a) => { if (a.dataset.lang === state.lang) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
}

// texts come translated in the page itself; re-applying them is only needed after a language switch
function renderAll(texts = true) {
  if (texts) applyI18n();
  renderCats(); renderBrands(); renderStyles(); renderSwatches(); renderIcons(); renderSegs(); renderSummary();
}

/* ================================================================ 3D / flat preview */
function refresh() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(applyRefresh);
}

// Apply the current state to the model right away (also used before taking the order renders).
function applyRefresh() {
  queued = false;
  const s = spec(), key = `${state.category}|${JSON.stringify(s)}`;
  if (viewer) {
    if (key !== builtKey) { viewer.build(state.category, s); builtKey = key; }
    viewer.setLook(state.design.baseColor, state.design.finish);
    viewer.paint(state.design, state.img, state.shuffle);
  } else if (flat) {
    const face = flatFace(s), k = 900 / Math.max(face.w, face.h);
    paintDesign(flat, { width: Math.round(face.w * k), height: Math.round(face.h * k), zones: [] }, state.design, state.img, state.shuffle);
  }
  renderSummary();
}

function flatFace(s) {
  if (state.category === 'gamepad') return { w: 160, h: 115 };
  return { w: s.w, h: s.h };
}

// lets the browser paint and handle input between the heavy steps of starting the 3D scene
const nextTask = () => new Promise((r) => setTimeout(r, 0));

async function initPreview() {
  const box = $('#viewer');
  let ok = false;
  try {
    const mod = await import('./viewer.js');
    await nextTask();
    if (mod.webglAvailable()) { viewer = new mod.Viewer(box); ok = true; }
  } catch (e) { console.warn('3D unavailable', e); }
  if (!ok) {
    $('#viewer-fallback').hidden = false;
    $('.viewer-tools').hidden = true;
    $('#viewer-hint').hidden = true;
    const wrap = document.createElement('div');
    wrap.className = 'viewer-flat';
    flat = document.createElement('canvas');
    wrap.appendChild(flat);
    box.appendChild(wrap);
  }
  if (viewer) {
    await nextTask();
    const s = spec();
    viewer.build(state.category, s); builtKey = `${state.category}|${JSON.stringify(s)}`;
    await nextTask();
    applyRefresh(); // colours and the painted design
    await nextTask();
    await viewer.start();
  } else refresh();
  $('#viewer-loading').classList.add('done');
  box.addEventListener('pointerdown', () => $('#viewer-hint').classList.add('gone'), { once: true });
  setTimeout(() => $('#viewer-hint').classList.add('gone'), 6000);
  // repaint once the brand font is ready so text renders in Unbounded
  if (document.fonts && document.fonts.load) document.fonts.load('800 64px Unbounded').then(refresh).catch(() => {});
}

/* ================================================================ upload */
function onFile(file) {
  showErr('upload', '');
  if (!file) return;
  const ext = (file.name.split('.').pop() || '').toLowerCase();
  if (!EXT_OK.includes(ext) || file.size > MAX_MB * 1024 * 1024) { showErr('upload', t('e.file')); return; }
  removeFile(false);
  state.file = file;
  $('#file-card').hidden = false;
  $('#file-name').textContent = file.name;
  $('#file-note').textContent = `${(file.size / 1024 / 1024).toFixed(1)} MB`;
  const thumb = $('#file-thumb');
  if (ext === 'pdf') {
    thumb.style.backgroundImage = ''; thumb.textContent = 'PDF';
    $('#file-note').textContent = t('f.pdfNote');
    $('#img-controls').hidden = true;
    renderStyles(); refresh();
    return;
  }
  const url = (state.objUrl = URL.createObjectURL(file));
  const img = new Image();
  img.onload = () => {
    if (!img.naturalWidth) { img.width = 1024; img.height = 1024; }
    state.img = img;
    thumb.textContent = ''; thumb.style.backgroundImage = `url("${url}")`;
    $('#img-controls').hidden = false;
    renderStyles(); refresh();
  };
  img.onerror = () => { showErr('upload', t('e.file')); removeFile(); };
  img.src = url;
}

function removeFile(rerender = true) {
  if (state.objUrl) URL.revokeObjectURL(state.objUrl);
  state.file = null; state.img = null; state.objUrl = null;
  $('#upload').value = '';
  $('#file-card').hidden = true;
  $('#img-controls').hidden = true;
  if (rerender) { renderStyles(); refresh(); }
}

/* ================================================================ submit */
function showErr(field, msg) {
  const el = $(`[data-err="${field}"]`);
  if (el) el.textContent = msg;
  const input = { name: '#name', phone: '#phone', model: '#other' }[field];
  if (input) $(input).classList.toggle('bad', !!msg);
}

function validate() {
  const errs = {};
  if (!$('#name').value.trim()) errs.name = t('e.name');
  const phone = $('#phone').value.trim();
  if (!/^[0-9+\-() ]{7,20}$/.test(phone) || phone.replace(/\D/g, '').length < 7) errs.phone = t('e.phone');
  if (isOther() && !state.other.trim()) errs.model = t('e.model');
  if (state.design.style === 'idea' && !state.file) errs.upload = t('e.upload');
  if (!$('#consent').checked) errs.consent = t('e.consent');
  return errs;
}

async function submit(e) {
  e.preventDefault();
  ['name', 'phone', 'model', 'upload', 'consent'].forEach((f) => showErr(f, ''));
  $('#form-err').textContent = '';
  const errs = validate();
  const keys = Object.keys(errs);
  if (keys.length) {
    keys.forEach((k) => showErr(k, errs[k]));
    const first = $(`[data-err="${keys[0]}"]`);
    if (first) first.closest('.o-step').scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }
  const btn = $('#submit'), label = $('#submit span');
  btn.disabled = true; label.textContent = t('o.sending');
  try {
    const order = {
      lang: state.lang,
      device: { category: state.category, brand: brandName(), model: isOther() ? 'other' : state.model, modelLabel: isOther() ? '' : modelLabel(), other: isOther() ? state.other.trim() : '' },
      design: { ...state.design, text: state.design.text.trim(), image: state.img ? { ...state.design.image } : null },
      contact: {
        name: $('#name').value.trim(), phone: $('#phone').value.trim(), telegram: $('#telegram').value.trim(),
        city: state.delivery === 'post' ? $('#city').value.trim() : (state.delivery === 'courier' ? 'Ташкент' : ''),
        delivery: state.delivery, address: $('#address').value.trim(), comment: $('#comment').value.trim(),
      },
      website: $('#website').value,
    };
    if (tg) {
      order.tg = tg.initData; // signed by Telegram: lets the bot send this customer status updates
      const user = tg.initDataUnsafe && tg.initDataUnsafe.user;
      if (user && !user.allows_write_to_pm && tg.requestWriteAccess) await new Promise((r) => { try { tg.requestWriteAccess(r); } catch (err) { r(false); } });
    }
    const fd = new FormData();
    fd.append('order', JSON.stringify(order));
    if (state.file) fd.append('upload', state.file, state.file.name);
    applyRefresh();
    if (viewer) {
      fd.append('preview_front', await viewer.snapshot('front'), 'front.png');
      fd.append('preview_back', await viewer.snapshot('back'), 'back.png');
      fd.append('texture', await viewer.textureBlob(), 'texture.png');
    } else if (flat) {
      fd.append('texture', await new Promise((r) => flat.toBlob(r, 'image/png')), 'texture.png');
    }
    const res = await fetch('/api/orders', { method: 'POST', body: fd });
    let data = {};
    try { data = await res.json(); } catch (err) { /* non-JSON */ }
    if (res.status === 201 && data.ok) return success(data);
    if (res.status === 429) return void ($('#form-err').textContent = t('e.rate'));
    const map = { invalid_name: 'name', invalid_phone: 'phone', upload_required: 'upload', file_too_large: 'upload', bad_file_type: 'upload', invalid_model: 'model' };
    const f = map[data.error];
    if (f) { showErr(f, f === 'upload' && data.error !== 'upload_required' ? t('e.file') : t('e.' + (f === 'upload' ? 'upload' : f))); return; }
    $('#form-err').textContent = t('e.server');
  } catch (err) {
    console.error(err);
    $('#form-err').textContent = t('e.server');
  } finally {
    btn.disabled = false; label.textContent = t('o.submit');
  }
}

function success({ number, linked, notify }) {
  $('#order-number').textContent = number;
  // status updates in Telegram: already linked inside the Mini App, otherwise a one-tap link to the bot
  const offer = Boolean(notify) && !linked;
  $('#ok-linked').hidden = !linked;
  $('#ok-tg').hidden = !offer;
  if (offer) {
    $('#ok-tg').href = notify;
    $('#ok-tg').onclick = tg ? (e) => { e.preventDefault(); tg.openTelegramLink(notify); } : null;
  }
  $('#ok-home').className = `btn ${offer ? 'btn-ghost' : 'btn-lime'}`;
  $('#success').hidden = false;
  document.body.style.overflow = 'hidden';
}

/* ================================================================ share */
// The design travels in the link (?d=…): device, style, colours, icons, text. The customer's own picture does not.
const b64url = {
  enc: (str) => btoa(String.fromCharCode(...new TextEncoder().encode(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''),
  dec: (str) => new TextDecoder().decode(Uint8Array.from(atob(str.replace(/-/g, '+').replace(/_/g, '/')), (c) => c.charCodeAt(0))),
};
const HEX = /^#[0-9a-f]{6}$/i;

function designCode() {
  const d = state.design;
  return b64url.enc(JSON.stringify({
    c: state.category, b: state.brand, m: state.model, o: isOther() ? state.other.trim() : undefined,
    s: d.style, bc: d.baseColor, ac: d.accentColor, ic: d.iconColor, tc: d.textColor,
    i: d.icons, k: d.iconScale, t: d.text.trim() || undefined, f: d.finish, x: state.shuffle || undefined,
  }));
}

function applyDesignCode(code) {
  let o;
  try { o = JSON.parse(b64url.dec(code)); } catch (e) { return; }
  if (!o || typeof o !== 'object') return;
  if (CATEGORIES.includes(o.c)) { state.category = o.c; pickDefaults(); }
  const br = brands().find((b) => b.id === o.b);
  if (br) {
    state.brand = br.id;
    state.model = br.models.some((m) => m.id === o.m) ? o.m : (br.models[0] ? br.models[0].id : '__other');
  }
  if (typeof o.o === 'string') state.other = o.o.slice(0, 80);
  const d = state.design;
  if (STYLES.includes(o.s)) d.style = o.s;
  for (const [k, key] of [['bc', 'baseColor'], ['ac', 'accentColor'], ['ic', 'iconColor'], ['tc', 'textColor']]) if (HEX.test(o[k] || '')) d[key] = o[k];
  if (Array.isArray(o.i)) d.icons = o.i.filter((id) => ICONS.some((ic) => ic.id === id)).slice(0, MAX_ICONS);
  if (typeof o.k === 'number' && o.k >= 0.5 && o.k <= 2) d.iconScale = o.k;
  if (typeof o.t === 'string') d.text = o.t.slice(0, 24);
  if (o.f === 'gloss' || o.f === 'matte') d.finish = o.f;
  if (Number.isInteger(o.x) && o.x >= 0 && o.x < 10000) state.shuffle = o.x;
  $('#other').value = state.other;
  $('#text').value = d.text;
  $('#icon-scale').value = d.iconScale;
}

const shareUrl = () => `${location.origin}${localize('/order', state.lang)}?d=${designCode()}`;

function loadImage(src) {
  return new Promise((resolve, reject) => { const im = new Image(); im.onload = () => resolve(im); im.onerror = reject; im.src = src; });
}

// shrinks the font ({px} in the CSS font string) until the text fits
function fitText(g, text, font, size, maxW) {
  let px = size;
  do { g.font = font.replace('{px}', px); px -= 2; } while (g.measureText(text).width > maxW && px > 20);
}

function roundRect(g, x, y, w, h, r) {
  g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
}

/** 1080×1920 picture for stories: the 3D render, the device and style, funmode.uz. */
async function storyBlob() {
  applyRefresh();
  const W = 1080, H = 1920, c = document.createElement('canvas');
  c.width = W; c.height = H;
  const g = c.getContext('2d');
  g.fillStyle = '#050505'; g.fillRect(0, 0, W, H);
  const glow = g.createRadialGradient(W / 2, 900, 40, W / 2, 900, 760);
  glow.addColorStop(0, 'rgba(215,255,0,0.20)'); glow.addColorStop(1, 'rgba(215,255,0,0)');
  g.fillStyle = glow; g.fillRect(0, 0, W, H);

  try {
    const logo = await loadImage('/assets/img/logo-wordmark.webp').catch(() => loadImage('/assets/img/logo-wordmark.jpg'));
    const lw = 420, lh = lw * logo.naturalHeight / logo.naturalWidth;
    g.globalCompositeOperation = 'screen';
    g.drawImage(logo, (W - lw) / 2, 90, lw, lh);
    g.globalCompositeOperation = 'source-over';
  } catch (e) { /* logo is decoration */ }

  const shot = viewer ? await loadImage(URL.createObjectURL(await viewer.snapshot('front', 1024))) : flat;
  const box = { x: 70, y: 410, w: 940, h: 940 };
  g.save(); roundRect(g, box.x, box.y, box.w, box.h, 48); g.clip();
  g.fillStyle = '#0b0b0a'; g.fillRect(box.x, box.y, box.w, box.h);
  if (shot) {
    const sw = shot.naturalWidth || shot.width, sh = shot.naturalHeight || shot.height, k = Math.min(box.w / sw, box.h / sh);
    g.drawImage(shot, box.x + (box.w - sw * k) / 2, box.y + (box.h - sh * k) / 2, sw * k, sh * k);
  }
  g.restore();
  roundRect(g, box.x, box.y, box.w, box.h, 48); g.lineWidth = 3; g.strokeStyle = 'rgba(247,247,242,0.22)'; g.stroke();
  if (shot && shot.src && shot.src.startsWith('blob:')) URL.revokeObjectURL(shot.src);

  g.textAlign = 'center'; g.textBaseline = 'alphabetic';
  g.fillStyle = '#D7FF00'; g.font = '700 34px Unbounded, sans-serif';
  g.fillText(t('share.mine').toUpperCase(), W / 2, 1450);
  const label = (modelLabel() || t('cat.' + state.category)).toUpperCase();
  g.fillStyle = '#F7F7F2'; fitText(g, label, '800 {px}px Unbounded, sans-serif', 72, 940);
  g.fillText(label, W / 2, 1545);
  g.fillStyle = '#9B9B95'; g.font = '600 40px Manrope, sans-serif';
  g.fillText(`${t('mode.' + state.design.style)} · ${t('fin.' + state.design.finish)}`, W / 2, 1610);

  const cta = t('share.cta').toUpperCase();
  fitText(g, cta, '800 {px}px Unbounded, sans-serif', 38, 820);
  const bw = Math.min(940, g.measureText(cta).width + 120), bh = 112, bx = (W - bw) / 2, by = 1690;
  roundRect(g, bx, by, bw, bh, 28); g.fillStyle = '#D7FF00'; g.fill();
  g.fillStyle = '#050505'; g.textBaseline = 'middle'; g.fillText(cta, W / 2, by + bh / 2 + 2);
  return new Promise((r) => c.toBlob(r, 'image/jpeg', 0.92));
}

let shareState = { url: '', file: null, objUrl: null };

async function openShare() {
  const dlg = $('#share');
  if (!dlg.showModal) return;
  if (shareState.objUrl) URL.revokeObjectURL(shareState.objUrl);
  shareState = { url: shareUrl(), file: null, objUrl: null };
  $('#share-img').removeAttribute('src');
  $('#share-loading').classList.remove('done');
  $('#share-note').hidden = !state.img;
  $('#share-note').textContent = state.img ? t('share.noImage') : '';
  $('#share-copy').textContent = t('share.copy');
  dlg.showModal();
  try {
    const blob = await storyBlob();
    shareState.file = new File([blob], 'funmode-design.jpg', { type: 'image/jpeg' });
    shareState.objUrl = URL.createObjectURL(blob);
    $('#share-img').src = shareState.objUrl;
    $('#share-save').href = shareState.objUrl;
    $('#share-save').download = 'funmode-design.jpg';
  } catch (err) {
    console.error(err);
  }
  $('#share-loading').classList.add('done');
  const canShareFile = shareState.file && navigator.canShare && navigator.canShare({ files: [shareState.file] });
  $('#share-send').hidden = !(tg || canShareFile || navigator.share);
  // Telegram's in-app browser can't download files: the picture is saved with a long press instead
  $('#share-save').hidden = Boolean(tg);
  if (tg) { $('#share-note').hidden = false; $('#share-note').textContent = [state.img ? t('share.noImage') : '', t('share.hold')].filter(Boolean).join(' '); }
}

async function sendShare() {
  const text = t('share.msg');
  if (tg) return tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(shareState.url)}&text=${encodeURIComponent(text)}`);
  try {
    if (shareState.file && navigator.canShare && navigator.canShare({ files: [shareState.file] })) {
      await navigator.share({ files: [shareState.file], text: `${text}: ${shareState.url}` });
    } else {
      await navigator.share({ title: 'FunMode', text, url: shareState.url });
    }
  } catch (err) { /* cancelled */ }
}

async function copyShare() {
  try {
    await navigator.clipboard.writeText(shareState.url);
  } catch (err) {
    const tmp = Object.assign(document.createElement('textarea'), { value: shareState.url });
    document.body.appendChild(tmp); tmp.select();
    try { document.execCommand('copy'); } catch (e) { /* nothing else to try */ }
    tmp.remove();
  }
  $('#share-copy').textContent = t('share.copied');
  setTimeout(() => { $('#share-copy').textContent = t('share.copy'); }, 2200);
}

/* ================================================================ Telegram Mini App */
function insideTelegram() {
  if (/tgWebApp/.test(location.hash)) return true;
  try { return Boolean(sessionStorage.getItem('__telegram__initParams')); } catch (e) { return false; }
}

async function initTelegram() {
  if (!insideTelegram()) return;
  await new Promise((r) => {
    const sc = document.createElement('script');
    sc.src = 'https://telegram.org/js/telegram-web-app.js';
    sc.onload = r; sc.onerror = r;
    document.head.appendChild(sc);
  });
  const app = window.Telegram && window.Telegram.WebApp;
  if (!app || !app.initData) return;
  tg = app;
  document.body.classList.add('in-tg');
  try {
    tg.ready(); tg.expand();
    if (tg.isVersionAtLeast('6.1')) { tg.setHeaderColor('#050505'); tg.setBackgroundColor('#050505'); }
    if (tg.isVersionAtLeast('7.7')) tg.disableVerticalSwipes(); // dragging the 3D model must not close the app
  } catch (e) { /* older Telegram */ }
  const user = tg.initDataUnsafe && tg.initDataUnsafe.user;
  if (!user) return;
  if (!$('#name').value) $('#name').value = [user.first_name, user.last_name].filter(Boolean).join(' ').slice(0, 80);
  if (!$('#telegram').value && user.username) $('#telegram').value = `@${user.username}`;
  // the bot opens /order; show the configurator in the user's Telegram language
  if (LANGS.includes(user.language_code) && user.language_code !== state.lang) switchLang(user.language_code);
}

/* ================================================================ events */
function bind() {
  $('#cats').addEventListener('click', (e) => {
    const b = e.target.closest('[data-cat]');
    if (!b || b.dataset.cat === state.category) return;
    state.category = b.dataset.cat; state.other = ''; $('#other').value = '';
    pickDefaults();
    renderCats(); renderBrands(); renderStyles(); refresh();
  });
  $('#brands').addEventListener('click', (e) => {
    const b = e.target.closest('[data-brand]');
    if (!b) return;
    state.brand = b.dataset.brand;
    const br = brands().find((x) => x.id === state.brand);
    state.model = br.models[0] ? br.models[0].id : '__other';
    renderBrands(); refresh();
  });
  $('#model').addEventListener('change', (e) => { state.model = e.target.value; renderBrands(); refresh(); });
  $('#other').addEventListener('input', (e) => { state.other = e.target.value; showErr('model', ''); renderSummary(); });

  $('#styles').addEventListener('click', (e) => {
    const b = e.target.closest('[data-style]');
    if (!b) return;
    state.design.style = b.dataset.style;
    renderStyles(); refresh();
  });

  const setColor = (row, c) => {
    if (row === 'base') state.design.baseColor = c;
    if (row === 'accent') state.design.accentColor = c;
    if (row === 'detail') { state.design.iconColor = c; state.design.textColor = c; }
  };
  $('#step-colors').addEventListener('click', (e) => {
    const b = e.target.closest('.sw');
    if (!b) return;
    setColor(b.dataset.row, b.dataset.color);
    renderSwatches(); refresh();
  });
  $('#step-colors').addEventListener('input', (e) => {
    if (e.target.type !== 'color') return;
    setColor(e.target.dataset.row, e.target.value);
    $$(`.sw[data-row="${e.target.dataset.row}"]`).forEach((s) => s.setAttribute('aria-pressed', 'false'));
    e.target.parentElement.dataset.on = 'true';
    refresh();
  });

  $('#icons').addEventListener('click', (e) => {
    const b = e.target.closest('[data-icon]');
    if (!b || b.disabled) return;
    const id = b.dataset.icon, list = state.design.icons;
    state.design.icons = list.includes(id) ? list.filter((x) => x !== id) : [...list, id].slice(0, MAX_ICONS);
    renderIcons(); refresh();
  });
  $('#icon-scale').addEventListener('input', (e) => { state.design.iconScale = +e.target.value; refresh(); });
  $('#shuffle').addEventListener('click', () => { state.shuffle++; refresh(); });

  $('#upload').addEventListener('change', (e) => onFile(e.target.files[0]));
  const drop = $('#drop');
  ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('over'); }));
  ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('over'); }));
  drop.addEventListener('drop', (e) => onFile(e.dataTransfer.files[0]));
  $('#file-remove').addEventListener('click', () => removeFile());
  for (const [id, key] of [['#img-scale', 'scale'], ['#img-x', 'x'], ['#img-y', 'y']]) {
    $(id).addEventListener('input', (e) => { state.design.image[key] = +e.target.value; refresh(); });
  }
  $('#text').addEventListener('input', (e) => { state.design.text = e.target.value; refresh(); });

  $('#finish').addEventListener('click', (e) => {
    const b = e.target.closest('[data-finish]');
    if (!b) return;
    state.design.finish = b.dataset.finish; renderSegs(); refresh();
  });
  $('#delivery').addEventListener('click', (e) => {
    const b = e.target.closest('[data-delivery]');
    if (!b) return;
    state.delivery = b.dataset.delivery; renderSegs();
  });
  ['name', 'phone'].forEach((f) => $('#' + f).addEventListener('input', () => showErr(f, '')));
  $('#consent').addEventListener('change', () => showErr('consent', ''));

  $('.viewer-tools').addEventListener('click', (e) => {
    const b = e.target.closest('[data-view]');
    if (!b || !viewer) return;
    const spinning = viewer.setView(b.dataset.view);
    $('[data-view="spin"]').setAttribute('aria-pressed', String(spinning));
    $('#viewer-hint').classList.add('gone');
  });
  $$('.lang-link').forEach((a) => a.addEventListener('click', (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    e.preventDefault();
    switchLang(a.dataset.lang);
  }));
  $('#order-form').addEventListener('submit', submit);

  $('#share-open').addEventListener('click', openShare);
  $('#ok-share').addEventListener('click', openShare);
  $('#share-send').addEventListener('click', sendShare);
  $('#share-copy').addEventListener('click', copyShare);
  $('#share-close').addEventListener('click', () => $('#share').close());
  $('#share').addEventListener('click', (e) => { if (e.target === $('#share')) $('#share').close(); });
}

// switch language in place so the design in progress is kept; the address changes to that language's page
function switchLang(lang) {
  if (!LANGS.includes(lang)) return;
  state.lang = lang;
  $$('a[href^="/"]:not(.lang-link)').forEach((l) => l.setAttribute('href', localize(l.getAttribute('href'), lang)));
  history.replaceState(null, '', localize(location.pathname, lang) + location.search + location.hash);
  renderAll();
}

/* ================================================================ admin view mode */
async function loadForView(id) {
  document.body.classList.add('view-mode');
  $('#view-banner').hidden = false;
  $('#view-admin').href = `/admin/#/order/${encodeURIComponent(id)}`;
  try {
    const res = await fetch(`/api/admin/orders/${encodeURIComponent(id)}`, { credentials: 'same-origin' });
    if (res.status === 401) { $('#view-number').textContent = '— ' + t('view.login'); return; }
    const { order } = await res.json();
    const cfg = order.config || {};
    const dev = cfg.device || {};
    state.category = CATEGORIES.includes(dev.category) ? dev.category : 'phone';
    const br = brands().find((b) => b.id === dev.brand || b.name === dev.brand) || brands().find((b) => b.id === 'other');
    state.brand = br.id;
    state.model = br.models.some((m) => m.id === dev.model) ? dev.model : '__other';
    state.other = dev.other || dev.modelLabel || '';
    Object.assign(state.design, cfg.design || {});
    if (!state.design.image) state.design.image = { scale: 1, x: 0, y: 0 };
    $('#view-number').textContent = order.number || '';
    const up = order.files && order.files.upload;
    if (up && /^image\/(png|jpe?g|webp)$/.test(order.upload_mime || '')) {
      const img = new Image();
      img.onload = () => { state.img = img; refresh(); };
      img.src = up + (up.includes('?') ? '&' : '?') + 'inline=1';
    }
    renderSummary(); refresh();
  } catch (e) {
    console.error(e);
  }
}

/* ================================================================ boot */
pickDefaults();
if (params.get('d') && !viewId) applyDesignCode(params.get('d'));
renderAll(document.documentElement.lang !== state.lang);
bind();
initPreview();
if (viewId) loadForView(viewId);
initTelegram();
